import React, { useCallback, useRef, useEffect, useState } from "react";
import logo from "../../../Assets/newsie-triumphant-192-removebg.png"; // Tell webpack this JS file uses this image

import { useDispatch } from "react-redux";

import { isValidEmail } from "../../../util/util";
import { CONFIG } from "../../../util/constants";
import TodaysStoriesPreview from "./TodaysStoriesPreview";
import TopicPicker from "../TopicPicker";
import "./LandingPageContainer.css";
import Confetti from "react-confetti";

const { SERVER_API } = CONFIG;

const LandingPageContainer = (props) => {
  const dispatch = useDispatch();
  const className = `landing-page-container`;
  const {
    date,
    handleClickHowToPlay,
    handleClickLoginButton,
    dismissModal,
    isLoggedIn,
    allNewsies,
  } = props;

  const ref = useRef(null);
  const pageContainerRef = useRef(null);

  const getDateString = (useCallback as any)((date) => {
    const dayOfTheWeek = new Date(date).toLocaleString("en", {
      timeZone: "UTC",
      weekday: "long",
    });
    const day = new Date(date).getUTCDate();
    const month = new Date(date).toLocaleString("default", {
      timeZone: "UTC",
      month: "long",
    });
    const year = new Date(date).getUTCFullYear();
    return `${dayOfTheWeek}, ${month} ${day}, ${year}`;
  });

  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);
  const [left, setLeft] = useState(0);

  useEffect(() => {
    if (ref.current) {
      setHeight(pageContainerRef.current.clientHeight);
      setWidth(ref.current.clientWidth);
    }
    if (pageContainerRef.current) {
      setLeft(pageContainerRef.current.getBoundingClientRect().left);
    }
  }, [ref.current, pageContainerRef.current]);

  const [subscribeEmail, setSubscribeEmail] = useState("");
  const [subscribeSuccess, setSubscribeSuccess] = useState(false);
  const [subscribeError, setSubscribeError] = useState(false);
  const isSubscribeEmailValid = isValidEmail(subscribeEmail);

  const handleSubscribeSubmit = async (e) => {
    e.stopPropagation();
    if (!isSubscribeEmailValid) return;
    setSubscribeError(false);
    const refSource = localStorage.getItem("refSource");
    const referralCode = localStorage.getItem("referralCode");
    try {
      const response = await fetch(`${SERVER_API}/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: subscribeEmail, refSource, referralCode }),
      });
      // 204 means the email was already subscribed - treat as success too
      if (!response.ok && response.status !== 204) {
        setSubscribeError(true);
        return;
      }
      setSubscribeSuccess(true);
    } catch (err) {
      setSubscribeError(true);
    }
  };

  return (
    <div ref={pageContainerRef} className={className} onClick={() => dismissModal()}>
      <div ref={ref} className="landing-page-hero">
        <div className="confetti-container" style={{ left }}>
          <Confetti
            numberOfPieces={50}
            width={width}
            height={height}
            opacity={0.3}
          />
        </div>
        <h4 className="landing-page-date">{date ? getDateString(date) : "..."}</h4>
        <div className="landing-page-hero-row">
          <img src={logo} width={56} height={56} alt="Logo" className="landing-page-hero-logo" />
          <div className="landing-page-hero-title-block">
            <h1>NEWSIE</h1>
            <p>Daily Newsletter &amp; News Quiz</p>
          </div>
        </div>
      </div>

      <ul className="landing-page-description">
        <li>📰 Today's top headlines, hidden behind clues</li>
        <li>🧠 Read the news, then test your memory</li>
        <li>📅 A brand new puzzle every day</li>
      </ul>

      {!isLoggedIn && (
        <div
          className="landing-page-subscribe-cta"
          onClick={(e) => e.stopPropagation()}
        >
          <span className="landing-page-subscribe-cta-badge">
            Free daily puzzle
          </span>
          <p className="landing-page-subscribe-cta-heading">
            📬 Get the Quiz by Email
          </p>
          <ul className="landing-page-subscribe-cta-subtext">
            <li>☀️ One short email each morning</li>
            <li>👆 Tap the link to play</li>
            <li>🚫 No spam, unsubscribe anytime</li>
          </ul>
          {subscribeSuccess ? (
            <div className="landing-page-subscribe-success">
              You're in! Check your inbox and tap the link to start playing 📬
            </div>
          ) : (
            <>
              <div className="landing-page-subscribe-input-row">
                <input
                  type="email"
                  placeholder="you@email.com"
                  value={subscribeEmail}
                  onChange={(e) => setSubscribeEmail(e.target.value)}
                  autoComplete="email"
                />
                <button
                  onClick={handleSubscribeSubmit}
                  disabled={!isSubscribeEmailValid}
                >
                  Subscribe
                </button>
              </div>
              {subscribeError && (
                <div className="landing-page-subscribe-error">
                  Something went wrong - please try again.
                </div>
              )}
            </>
          )}
        </div>
      )}

      {/* Guests see the email banner instead, so subscribing is how they get the news */}
      {isLoggedIn && <TodaysStoriesPreview allNewsies={allNewsies} />}

      <div className="landing-page-button-container">
        <TopicPicker isLoggedIn={isLoggedIn} />
        <div className="landing-page-secondary-button-row">
          <div
            className="landing-page-how-to-play-button"
            onClick={(e) => {
              e.stopPropagation();
              handleClickHowToPlay();
            }}
          >
            How to play
          </div>
          {!isLoggedIn && (
            <div
              className="landing-page-login-button"
              onClick={(e) => {
                e.stopPropagation();
                handleClickLoginButton();
              }}
            >
              Login
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LandingPageContainer;
